import React from "react";
import "./WhySerene.css";
import Navbar from "../../Components/Navbar/Navbar";
import Topbar from "../../Components/Topbar/Topbar";
import Banner from "../../Components/Banner/Banner";
import GetInTouch from "../Home/Components/GetInTouch/GetInTouch";
import Footer from "../../Components/Footer/Footer";
import Experienced from "./Components/Experienced/Experienced";
import Professional from "./Components/Professional/Professional";
import Affordable from "./Components/Affordable/Affordable";
import DataIntegrity from "./Components/DataIntegrity/DataIntegrity";
const WhySerene = () => {
  return (
    <div className="why__serene__screen">
      <Topbar />
      <Navbar />
      <Banner content="Why Serene" />
      <Experienced />
      <Professional />
      <Affordable />
      <DataIntegrity />
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default WhySerene;
